<div class="twc-row">
    <div class="twc-form-control">
        <span class="twc-tiny twc-pl-4">{{tag}}</span>
        <div class="twc-form-element margin">
            <input class="twc-input" [(ngModel)]="value" maxlength="3" (change)="valueChange($event.target)"
                [disabled]="disabled" [readonly]="readonly" (keydown)="limitInputCharacters($event)">
        </div>
    </div>
</div>